import lodash from 'lodash';
import moment from 'moment';

import { reportTypes, DATE_FORMAT } from './constants';
import { nodeWithArgs } from 'common/util/queryHelper';
import styles from '../containers/ReportContent.scss';

export const expiringDocumentReportColumns = {
    documentId: { key: 'documentId', label: 'Document ID', filter: 'Filter ID' },
    documentName: { key: 'documentName', label: 'Document Name', filter: 'Filter name' },
    documentType: { key: 'documentType', label: 'Document Type', filter: 'Filter type' },
    nameOfResearcher: { key: 'nameOfResearcher', label: 'Name of Researcher', filter: 'Filter researcher' },
    nameOfLab: { key: 'nameOfLab', label: 'Name of Lab', filter: 'Filter lab' },
    expirationDate: { key: 'expirationDate', label: 'Expiration Date', filter: 'Filter date' },
};

export const expiringDocumentReportDefaultColumns = [
    expiringDocumentReportColumns.documentId.key,
    expiringDocumentReportColumns.documentName.key,
    expiringDocumentReportColumns.documentType.key,
    expiringDocumentReportColumns.nameOfResearcher.key,
    expiringDocumentReportColumns.nameOfLab.key,
    expiringDocumentReportColumns.expirationDate.key,
];

const expiringDocumentReportColumnsValues = lodash.values(expiringDocumentReportColumns);
export const expiringDocumentReportColumnsList = lodash.orderBy(expiringDocumentReportColumnsValues, ['label'], ['asc']);

export const getExpiringDocumentsReportNode = (institutionId) => {
    return nodeWithArgs('getExpiringDocumentsReportRawData', {
        institutionId,
    }, [
        'documentId',
        'documentName',
        'documentType',
        'expirationDate',
        'nameOfResearcher',
        'nameOfLab',
    ]);
};

export function renderExpiringDocumentsColumns(reportData, customizeColumns) {
    if (lodash.isEmpty(reportData)) {
        return [];
    }
    const formattedColumns = formatMaterialTableEDColumns(customizeColumns);

    return [...formattedColumns];
}

const formatMaterialTableEDColumns = customizeColumns => {
    return [
        {
            title: expiringDocumentReportColumns.documentId.label,
            field: expiringDocumentReportColumns.documentId.key,
            filterPlaceholder: expiringDocumentReportColumns.documentId.filter,
            hidden: !customizeColumns.includes(expiringDocumentReportColumns.documentId.key),
            emptyValue: <p className={styles.emptyLabel}>No D.I Provided</p>,
        },
        {
            title: expiringDocumentReportColumns.documentName.label,
            field: expiringDocumentReportColumns.documentName.key,
            filterPlaceholder: expiringDocumentReportColumns.documentName.filter,
            hidden: !customizeColumns.includes(expiringDocumentReportColumns.documentName.key),
            emptyValue: <p className={styles.emptyLabel}>No D.N Provided</p>,
            cellStyle: {
                minWidth: '250px',
            },
        },
        {
            title: expiringDocumentReportColumns.documentType.label,
            field: expiringDocumentReportColumns.documentType.key,
            filterPlaceholder: expiringDocumentReportColumns.documentType.filter,
            hidden: !customizeColumns.includes(expiringDocumentReportColumns.documentType.key),
        },
        {
            title: expiringDocumentReportColumns.nameOfResearcher.label,
            field: expiringDocumentReportColumns.nameOfResearcher.key,
            filterPlaceholder: expiringDocumentReportColumns.nameOfResearcher.filter,
            hidden: !customizeColumns.includes(expiringDocumentReportColumns.nameOfResearcher.key),
            emptyValue: <p className={styles.emptyLabel}>No N.o.R Provided</p>,
        },
        {
            title: expiringDocumentReportColumns.nameOfLab.label,
            field: expiringDocumentReportColumns.nameOfLab.key,
            filterPlaceholder: expiringDocumentReportColumns.nameOfLab.filter,
            hidden: !customizeColumns.includes(expiringDocumentReportColumns.nameOfLab.key),
            emptyValue: <p className={styles.emptyLabel}>No N.o.L Provided</p>,
        },
        {
            title: expiringDocumentReportColumns.expirationDate.label,
            field: expiringDocumentReportColumns.expirationDate.key,
            filterPlaceholder: expiringDocumentReportColumns.expirationDate.filter,
            hidden: !customizeColumns.includes(expiringDocumentReportColumns.expirationDate.key),
            emptyValue: <p className={styles.emptyLabel}>No E.D Provided</p>,
            render: rowData => {
                return moment(rowData[expiringDocumentReportColumns.expirationDate.key]).format(DATE_FORMAT);
            },
        },
    ];
};

export const reportExpiringDocumentsOptionData = {
    name: reportTypes.expiringDocument,
    displayName: 'Expiring Documents Reports',
    reportType: reportTypes.expiringDocument,
    parameters: [
        {
            id: 'institutionId',
            choice: 'institutionId',
            choiceLabel: 'Get a report on all binders for this Institution',
            isChoiceRequired: true,
            isChoiceHidden: true,
            label: 'Institution Id',
            type: null,
            source: null,
            dataKey: 'institutionId',
            target: 'institutionId',
            submit: true,
        },
        {
            id: 'all',
            choice: 'expirationDate',
            choiceLabel: 'Choose a date to restrict results to:',
            isChoiceRequired: true,
            isChoiceHidden: false,
            label: 'Include all expiring documents',
            type: null,
            source: null,
            target: null,
            submit: false,
        },
        {
            id: 'expirationDate',
            choice: 'expirationDate',
            choiceLabel: 'Choose a date to restrict results to:',
            isChoiceRequired: false,
            label: 'Include only documents that have expiration date less than or equal to',
            type: 'datePicker',
            source: 'null',
            dataKey: 'expirationDate',
            target: 'expirationDate',
            submit: true,
        },
    ],
};
